module.exports = __webpack_public_path__ + "media/images/game_icon/th/AB1501-a487a21de968d15236a55ca7cdb80173.png";